import { useQuery } from "@tanstack/react-query";
import queryKey from "../../../../enumerations/queryKey";
import { getDownlineOverview } from "../service";

export const useGetDownlineOverview = (options) => {
  return useQuery(
    [queryKey.DOWNLINE_OVERVIEW],
    () => getDownlineOverview({}).then((res) => res.data),
    {
      ...options,
    }
  );
};
